export const SET_VIDEOS = 'VideoFeed/SET_VIDEOS';

export function setVideos(videos) {
  return {
    type: SET_VIDEOS,
    payload: { videos }
  };
}



// WEBPACK FOOTER //
// ./src/containers/VideoFeed/actions.js